import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function ProjectCard({ project }) {
  return (
    <div className="bg-[#0f0f0fd9] rounded-2xl p-[10px] flex flex-col h-full group border-[1px] border-solid border-[#ffffff3b] hover:bg-[#151515] transition-colors duration-300">
      {/* Image Container */}
      <div className="rounded-xl overflow-hidden mb-[24px] bg-[#1a1a1a] aspect-video w-full relative">
        <Image
          src={project.image}
          alt={project.title}
          fill
          className="object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      {/* Content */}
      <div className="flex flex-col flex-grow">
        {/* Tag */}
        <div className="flex items-center gap-[8px] mb-[12px]">
          <span className={`w-[8px] h-[8px] rounded-full ${project.tagColor}`}></span>
          <span className="text-[#9ca3af] text-[12px] font-medium">{project.category}</span>
        </div>

        {/* Title & Description */}
        <h3 className="text-white text-[16px] md:text-[18px] font-bold mb-[8px]">{project.title}</h3>
        <p className="text-[#9ca3af] text-[13px] leading-[1.375] mb-[20px] flex-grow">
          {project.description}
        </p>

        {/* Action Link */}
        <Link
          href={project.link}
          className="inline-flex items-center gap-[6px] text-[#f1833b] text-[14px] font-medium group/link mt-auto"
        >
          View {project.title}
          <svg
            className="w-4 h-4 transform group-hover/link:translate-x-1 transition-transform"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </Link>
      </div>
    </div>
  );
}
